import { render, staticRenderFns } from "./SomePage2.vue?vue&type=template&id=d6cd81d2&scoped=true&"
import script from "./SomePage2.vue?vue&type=script&lang=js&"
export * from "./SomePage2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6cd81d2",
  null
  
)

export default component.exports